import { useEffect, useState } from "react";

import { countdownLabel, elapsedLabel, formatDate, formatDateTime, parseDateTime, userTimeZone } from "../utils/dateTime";

const countdownWindow = 24 * 60 * 60 * 1000;

export function LocalDateTime({ value, status, fallback = "Time not announced" }: { value?: string; status?: string; fallback?: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if ((status !== "scheduled" && status !== "ongoing") || !value) return;
    const timer = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(timer);
  }, [status, value]);
  if (!value) return <span className="local-date-time local-date-time-empty">{fallback}</span>;
  const parsed = parseDateTime(value);
  const remaining = parsed ? parsed.getTime() - now : 0;
  const countdown = status === "scheduled" && remaining > 0 && remaining <= countdownWindow;
  // Source status often lags behind the published start time. Until a match is
  // explicitly completed, a past start is the best available live signal.
  const elapsed = status !== "completed" && remaining <= 0;
  return <span className="local-date-time" title={`Shown in ${userTimeZone()}`}>
    <time dateTime={parsed?.toISOString()}>{formatDateTime(value)}</time>
    {countdown && <strong className="match-countdown" aria-label={countdownLabel(remaining)}>{countdownLabel(remaining)}</strong>}
    {elapsed && <strong className="match-elapsed" aria-label={elapsedLabel(-remaining)}>{elapsedLabel(-remaining)}</strong>}
  </span>;
}

export function LocalDate({ value }: { value: string }) {
  return <time className="local-date" dateTime={value}>{formatDate(value)}</time>;
}

export function LocalDateRange({ start, end }: { start: string; end: string }) {
  return <span className="local-date-range"><LocalDate value={start} /> <span aria-hidden="true">—</span> <LocalDate value={end} /></span>;
}
